const PLUGIN_NAME = 'boat-local';

export { PLUGIN_NAME };
